// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mnfwgdxgthnojhcufndt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1uZndnZHhndGhub2poY3VmbmR0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwMTQyODIsImV4cCI6MjA1ODU5MDI4Mn0.d-DhDqzkMVCISKamcecsmpwuctHFZrDoAzjSA_rGI_I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);